import React from "react";
import hero from "../../assets/newImg/bannerRide.jpg";

const Hero = () => {
  return (
    <div className="relative w-full">
      {/* Background Image */}
      <img
        src={hero}
        alt="Ride now"
        className="w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/30"></div>

      {/* Content */}
    </div>
  );
};

export default Hero;
